import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const PREMIUM_MODAL_CONTENT_TYPES = {
  REVERSE_INTEREST: 'REVERSE_INTEREST',
  INTEREST_MARKS: 'INTEREST_MARKS',
  NO_INTEREST_MARKS: 'NO_INTEREST_MARKS'
};

const state = {
  showMobileHeader: true,
  showDesktopHeader: true,
  showGlobalModal: '',
  showCookiesModal: false,
  propositionViewModalId: null,
  propositionViewModalId2: null,
  propositionType: null,
  pageModalActivePage: 'proposition',
  pageModalZIndex: null,
  disableScroll: [],
  activeModals: [],
  usedModals: [],
  currentModal: '',
  tabAnsweredClicks: 0,
  // The swap list tutorial overlay is up: page chrome that would sit on top
  // of it (the feedback tab) hides meanwhile.
  tutorialActive: false,
  endMatchConfirm: {
    show: false,
    params: null,
    onConfirm: null,
    onCancel: null
  },
  // { summary, recentVisitors } for the CompleteListingModal.
  completeListingModalData: null
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
